module.exports = __webpack_public_path__ + "img/leumi-large.2ba25adb.svg";